module.exports = __webpack_public_path__ + "static/media/art_market_slider_1.10f4ea06.png";